// src/auth/jwt-cookie.ts
import Cookies from 'js-cookie'
import { jwtPayloadSchema, type User } from '@/types/jwt-cookie'

const ACCESS_TOKEN_COOKIE = 'jwt_hp'
const REFRESH_MARGIN_MS = 30_000

function decodeBase64UrlJson(value: string): unknown {
  const normalized = value
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .padEnd(Math.ceil(value.length / 4) * 4, '=')

  const bytes = Uint8Array.from(atob(normalized), (character) => character.charCodeAt(0))

  return JSON.parse(new TextDecoder().decode(bytes))
}

export function readAccessTokenPayload(): User | null {
  const token = Cookies.get(ACCESS_TOKEN_COOKIE)

  if (!token) {
    return null
  }

  const parts = token.split('.')

  /*
   * Lexik split-cookie met header + payload:
   * base64url(header).base64url(payload)
   */
  if (parts.length !== 2) {
    return null
  }

  try {
    const result = jwtPayloadSchema.safeParse(decodeBase64UrlJson(parts[1]))

    return result.success ? result.data : null
  } catch {
    return null
  }
}

export function accessTokenNeedsRefresh(marginMs = REFRESH_MARGIN_MS): boolean {
  const payload = readAccessTokenPayload()

  if (!payload) {
    return true
  }

  return payload.exp * 1_000 <= Date.now() + marginMs
}
